// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".styles-module__SmallModal__1GIgQ{background:var(--BrandForest)}.styles-module__SmallModal__1GIgQ>div:last-child{justify-content:center}.styles-module__Error__3VfbI{width:100%;max-width:40rem;margin:0 auto;text-align:center;padding-top:56px}", ""]);
// Exports
exports.locals = {
	"SmallModal": "styles-module__SmallModal__1GIgQ",
	"Error": "styles-module__Error__3VfbI"
};
export default exports;
